var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { t, Translate } from "../../I18N";
import SidePanel from "../../Layout/SidePanel";
import { resetFilters } from "../actions/filterActions";
import FiltersForm from "./FiltersForm";
import { wrapDispatch } from "../../Multireducer";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon } from "../../UI";
import { hideFilters } from "../../Entities/actions/uiActions";
import { withRouter } from "../../componentWrappers";

class LibraryFilters extends Component {
  reset() {
    this.props.resetFilters(this.props.navigate, this.props.location);
  }

  render() {
    return /*#__PURE__*/(
      _jsx(SidePanel, {
        className: "library-filters",
        "data-testid": "library-filters",
        mode: this.props.sidePanelMode,
        open: this.props.open }, void 0, /*#__PURE__*/

      _jsx("div", { className: "sidepanel-body" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "sidepanel-title" }, void 0, /*#__PURE__*/
      _jsx("div", {}, void 0, t('System', 'Filters configuration')), /*#__PURE__*/
      _jsx("div", { className: "filter-buttons" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: `closeSidepanel ${
        this.props.sidePanelMode === 'unpinned-mode' ? '' : 'only-mobile'
        }`,
        onClick: this.props.hideFilters,
        "aria-label": "Close side panel" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "times" })
      )
      )
      ), /*#__PURE__*/
      _jsx(FiltersForm, { storeKey: this.props.storeKey })
      ), /*#__PURE__*/
      _jsx("div", { className: "sidepanel-footer" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", className: "btn btn-default", onClick: this.reset.bind(this) }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "times" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Clear Filters")
      )
      )
      )
      ));

  }
}

LibraryFilters.defaultProps = {
  open: false,
  storeKey: 'library',
  sidePanelMode: '',
  hideFilters: () => {}
};











function mapStateToProps(state, props) {
  const noDocumentSelected = state[props.storeKey].ui.get('selectedDocuments').size === 0;
  const isFilterShown = state[props.storeKey].ui.get('filtersPanel') !== false;
  return {
    open: noDocumentSelected && isFilterShown
  };
}

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators({ resetFilters, hideFilters }, wrapDispatch(dispatch, props.storeKey));
}

export { LibraryFilters, mapStateToProps };

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LibraryFilters));